export default "__VITE_ASSET__lMSTrLOG__"